// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
  min-height: 100vh;
  background: var(--mrt-bg);
}

.settings-wrap {
  max-width: 1100px;
  margin: 0 auto;
  padding: 18px;
}

.settings-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.settings-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 900;
  color: var(--mrt-text);
}

.settings-sub {
  margin-top: 2px;
  font-size: 12px;
  color: var(--mrt-muted);
}

.settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.settings-card {
  background: var(--mrt-surface);
  border: 1px solid var(--mrt-border);
  border-radius: 12px;
  padding: 14px;
}

.settings-card-title {
  font-weight: 900;
  color: var(--mrt-text);
  margin-bottom: 10px;
}

.settings-card--span {
  grid-column: 1 / -1;
}

.settings-kv {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--mrt-border-2);
  align-items: center;
}

.settings-kv .k {
  font-size: 12px;
  color: var(--mrt-muted);
  font-weight: 800;
}

.settings-kv .v {
  font-size: 12px;
  color: var(--mrt-text);
  font-weight: 900;
  word-break: break-word;
}

.settings-row {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 10px;
}

.settings-radio {
  font-size: 12px;
  font-weight: 900;
  color: var(--mrt-text);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.settings-checkbox {
  font-size: 12px;
  font-weight: 900;
  color: var(--mrt-text);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.settings-form {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.settings-field .label {
  font-size: 11px;
  color: var(--mrt-muted);
  font-weight: 900;
  margin-bottom: 6px;
}

.settings-field input {
  width: 100%;
  height: 36px;
  border-radius: 10px;
  border: 1px solid var(--mrt-border);
  background: var(--mrt-surface);
  color: var(--mrt-text);
  padding: 0 10px;
  font-size: 13px;
  outline: none;
}

.settings-hint {
  grid-column: 1 / -1;
  font-size: 11px;
  color: var(--mrt-muted);
}

.settings-btn {
  background: var(--mrt-btn-bg);
  color: var(--mrt-btn-text);
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  font-weight: 900;
  cursor: pointer;
}

.settings-btn-primary {
  background: #2563eb;
}

.settings-btn--ghost {
  background: transparent;
  color: var(--mrt-text);
  border: 1px solid var(--mrt-border);
}

.settings-error {
  background: var(--mrt-surface);
  border: 1px solid var(--mrt-danger-border);
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 12px;
}

.settings-error-title {
  font-weight: 900;
  color: var(--mrt-danger);
  margin-bottom: 6px;
}

.settings-error-msg {
  font-size: 12px;
  color: var(--mrt-text);
  white-space: pre-wrap;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.settings-section {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed var(--mrt-border);
}

.settings-section-title {
  font-weight: 900;
  font-size: 12px;
  color: var(--mrt-text-2);
  margin-bottom: 8px;
}

.settings-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.settings-menu-item-left {
  min-width: 0;
}

.settings-menu-item-name {
  font-weight: 900;
  color: var(--mrt-text);
  font-size: 13px;
}

.settings-menu-item-sub {
  margin-top: 2px;
  color: var(--mrt-muted);
  font-size: 11px;
}

@media (max-width: 900px) {
  .settings-grid {
    grid-template-columns: 1fr;
  }
  .settings-form {
    grid-template-columns: 1fr;
  }
}



`, "",{"version":3,"sources":["webpack://./src/pages/Settings.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,cAAc;EACd,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,+GAA+G;AACjH;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".settings-container {\n  min-height: 100vh;\n  background: var(--mrt-bg);\n}\n\n.settings-wrap {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 18px;\n}\n\n.settings-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.settings-title h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 900;\n  color: var(--mrt-text);\n}\n\n.settings-sub {\n  margin-top: 2px;\n  font-size: 12px;\n  color: var(--mrt-muted);\n}\n\n.settings-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.settings-card {\n  background: var(--mrt-surface);\n  border: 1px solid var(--mrt-border);\n  border-radius: 12px;\n  padding: 14px;\n}\n\n.settings-card-title {\n  font-weight: 900;\n  color: var(--mrt-text);\n  margin-bottom: 10px;\n}\n\n.settings-card--span {\n  grid-column: 1 / -1;\n}\n\n.settings-kv {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--mrt-border-2);\n  align-items: center;\n}\n\n.settings-kv .k {\n  font-size: 12px;\n  color: var(--mrt-muted);\n  font-weight: 800;\n}\n\n.settings-kv .v {\n  font-size: 12px;\n  color: var(--mrt-text);\n  font-weight: 900;\n  word-break: break-word;\n}\n\n.settings-row {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.settings-radio {\n  font-size: 12px;\n  font-weight: 900;\n  color: var(--mrt-text);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.settings-checkbox {\n  font-size: 12px;\n  font-weight: 900;\n  color: var(--mrt-text);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.settings-form {\n  margin-top: 10px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.settings-field .label {\n  font-size: 11px;\n  color: var(--mrt-muted);\n  font-weight: 900;\n  margin-bottom: 6px;\n}\n\n.settings-field input {\n  width: 100%;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid var(--mrt-border);\n  background: var(--mrt-surface);\n  color: var(--mrt-text);\n  padding: 0 10px;\n  font-size: 13px;\n  outline: none;\n}\n\n.settings-hint {\n  grid-column: 1 / -1;\n  font-size: 11px;\n  color: var(--mrt-muted);\n}\n\n.settings-btn {\n  background: var(--mrt-btn-bg);\n  color: var(--mrt-btn-text);\n  border: none;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-weight: 900;\n  cursor: pointer;\n}\n\n.settings-btn-primary {\n  background: #2563eb;\n}\n\n.settings-btn--ghost {\n  background: transparent;\n  color: var(--mrt-text);\n  border: 1px solid var(--mrt-border);\n}\n\n.settings-error {\n  background: var(--mrt-surface);\n  border: 1px solid var(--mrt-danger-border);\n  border-radius: 12px;\n  padding: 14px;\n  margin-bottom: 12px;\n}\n\n.settings-error-title {\n  font-weight: 900;\n  color: var(--mrt-danger);\n  margin-bottom: 6px;\n}\n\n.settings-error-msg {\n  font-size: 12px;\n  color: var(--mrt-text);\n  white-space: pre-wrap;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n.settings-section {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px dashed var(--mrt-border);\n}\n\n.settings-section-title {\n  font-weight: 900;\n  font-size: 12px;\n  color: var(--mrt-text-2);\n  margin-bottom: 8px;\n}\n\n.settings-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.settings-menu-item-left {\n  min-width: 0;\n}\n\n.settings-menu-item-name {\n  font-weight: 900;\n  color: var(--mrt-text);\n  font-size: 13px;\n}\n\n.settings-menu-item-sub {\n  margin-top: 2px;\n  color: var(--mrt-muted);\n  font-size: 11px;\n}\n\n@media (max-width: 900px) {\n  .settings-grid {\n    grid-template-columns: 1fr;\n  }\n  .settings-form {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
